import React, {FC, memo} from "react";
import {Space} from "antd";
import NotFound from "../../containers/common/NotFound";
import {Course, GetBookingByIdQuery, GetBookingByIdWithCourseLessonBookingsQuery, GetCourseByIdQuery, useGetCourseByIdQuery} from "../../generated/graphql";
import i18n from "../../services/i18n";
import LoadingContent from "../LoadingContent/LoadingContent";
import css from "./PanelCardCourseData.less";
import RenderCourseLessons from "./RenderCourseLessons";
import RenderCourseDetails from "./RenderCourseDetails";

type PanelCardCourseDataProps = {
    courseId: Course["id"];
    booking?: GetBookingByIdQuery["bookingById"] | GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"];
    // panels?: CourseDetailsPanels;
    overview?: boolean;
    lessons?: boolean;
    extra?: React.ReactNode;
    gapAfter?: boolean;
};

const PanelCardCourseData: FC<PanelCardCourseDataProps> = ({courseId, booking, overview = true, lessons = false, extra, gapAfter = true}) => {
    const {data, loading} = useGetCourseByIdQuery({variables: {id: courseId}});

    const course: GetCourseByIdQuery["courseById"] | undefined = data?.courseById;

    if (course === undefined) {
        if (loading) {
            return <LoadingContent content={<div>{"Buchungsdaten werden geladen..."}</div>} />;
        }

        return <NotFound />;
    }

    const cardTitle = (
        <Space>
            <div>{i18n.containers.courses.CourseDetails.courseData()}</div>
            <div style={{opacity: 0.33}}>{course.prefixedCourseNumber}</div>
        </Space>
    );

    return (
        <>
            {overview && <RenderCourseDetails course={course} cardTitle={cardTitle} extra={extra} gapAfter={gapAfter} />}
            {lessons && <RenderCourseLessons course={course} booking={booking} gapAfter={gapAfter} />}
        </>
    );
};

export default memo(PanelCardCourseData);
